import React, { useMemo } from "react";
import Table from "../../../components/coreUiTable/Table";
import { useSelector } from "react-redux";
import { cuFormat } from "../../../components/coreUiTable/Format";
import ReactTooltip from "react-tooltip";

const calculateWidth = (length) => `${100 / length - 0.8}%`;

const getCardsWithWidth = (cardsData = []) => {
  const availableCards = cardsData.filter((elem) => elem.values.length);
  if (!availableCards.length) return [];

  const topLength = Math.ceil(availableCards.length / 2);
  const bottomLength = availableCards.length - topLength;

  return availableCards.map((card, idx) => {
    if (availableCards.length <= 4) {
      card.width = calculateWidth(availableCards.length);
      return card;
    }
    if (idx < topLength) {
      card.width = calculateWidth(topLength);
      return card;
    }
    card.width = calculateWidth(bottomLength);
    return card;
  });
};

const MetricsCard = () => {
  const cardsData = useSelector((state) => state.brandLeaderboard.cardsData);
  const clHeaders = ["Rank", "Location", "Total"];

  const addTooltip = (header, formattedValue) =>
    header === "Location" ? (
      <span data-tip={formattedValue}>{formattedValue}</span>
    ) : (
      formattedValue
    );

  const cardsWithWidth = useMemo(() => getCardsWithWidth(cardsData?.all_data), [cardsData]);
  return (
    <div className="cards-wrapper">
      {cardsWithWidth.map((elem, idx) => {
        const formattedSlots = cuFormat({
          customFn: (header, formattedValue) => addTooltip(header, formattedValue),
          headers: clHeaders,
          columns: cardsData.columns[idx]
        });

        return (
          <div className="metrics-card" key={elem.label} style={{ width: elem.width }}>
            <div className="card-header">{elem.label}</div>
            <div className="card-table">
              <ReactTooltip effect="solid" />
              <Table
                key={`lead-board-table-${idx}`}
                cName="brand-leader-board-table"
                tableFilter={false}
                pagination={false}
                sorter
                showCount
                scopedSlots={formattedSlots}
                table={{
                  colHeaders: clHeaders,
                  data: elem.values
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MetricsCard;
